import { writable } from 'svelte/store';

export const ActiveTab = writable(localStorage.getItem(`adminStore.activeTab`) ?? 'dashboard')
ActiveTab.subscribe((val) => localStorage.setItem(`adminStore.activeTab`, val))